<!-- 帖子 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <!-- <el-button type="primary" size="small" @click="handleAdd" style="margin: 0 20px 0 0">录入</el-button> -->
      <el-form-item label="内容: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.meaasge" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="用户openid: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="状态:" style="margin: 0px 20px 0 0" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>-->

      <el-button type="primary" @click="search" size="small" style="margin: 0 0px 10 0">搜索</el-button>
      <!-- <el-button
        class="addBtn"
        type="primary"
        size="small"
        style="margin-right: 20px"
        :loading="downloadLoading"
        icon="el-icon-document"
        @click="handleDownload"
      >
        导出 Excel（数量/ {{ tableData.length
        }}条）
      </el-button>-->
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="phone" slot-scope="{ row }">
          <!-- <el-image
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>-->
          {{row.phone?row.phone:'暂无'}}
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.status==1">审核中</el-tag>
          <el-tag type="success" effect="dark" size="mini" v-if="row.status==2">审核通过</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-if="row.status==3">审核拒绝</el-tag>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" primary>审核</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 表单弹窗 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form
        ref="form"
        :model="dialogForm"
        label-width="120px"
        style="max-height: 550px; overflow-y: auto;"
      >
        <el-form-item label="帖子内容" required>
          <el-input
            clearable
            v-model="dialogForm.message"
            placeholder="请输入"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item>

        <el-form-item label="帖子状态: ">
          <el-select v-model="dialogForm.status" placeholder="请选择" clearable>
            <div v-for="item in statusList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { selectApi, deleteApi, addApi, updateApi } from "@/services/tieba/list";
export default {
  components: {
    ElTable
  },
  created() {
    this.getListData();
  },
  data() {
    return {
      downloadLoading: false,
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: ""
      },
      stateList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      /* 表格数据 */
      tableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},

      dialogVisible_read: false,
      dialogForm_read: {},

      statusList: [
        { id: 1, name: "审核中" },
        { id: 2, name: "审核通过" },
        { id: 3, name: "审核拒绝" }
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    listHeader,
    ...mapState(["supUser"])
  },

  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectApi(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建";
      this.dialogForm = {
        message: []
      };
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "审核数据";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.imgUrl = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    /* 保存 */
    save() {
      console.log("this.dialogForm", this.dialogForm);
      if (!this.dialogForm.message && !this.dialogForm.status) {
        this.$message.error("请填写必填字段");
        return;
      }

      updateApi({
        ...this.dialogForm
      }).then(res => {
        if (res.code === 200) {
          this.getListData();
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
          this.dialogVisible = false;
        }
      });
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteApi({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 导出数据 */
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "ID",
          "检测标题",
          "用户小程序openid",
          "用户手机号",
          "",
          "创建时间"
        ];
        const filterVal = [
          "id",
          "title",
          "openid",
          "phone",
          "message",
          "createTime"
        ];
        const list = this.tableData.map(item => {
          return {
            ...item
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "患者下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    handleAddItem() {
      console.log("this.dialogForm.message", this.dialogForm.message);
      this.dialogForm.message.push({
        keyName: "",
        key: "",
        value: ""
      });
    },

    handleDeleteItem(index) {
      this.dialogForm.message.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  padding: 20px;
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

.dialogForm_read {
  border: 1px dotted #000000;
}
.dialogForm_read_item {
  display: flex;
  margin: 20px auto;
  width: 95%;
  background: #f2f2f2;
  padding: 10px 0;
}
.dialogForm_read_item > span:first-child {
  font-weight: 550;
}
</style>
